import useAdminUsersFetch from './hooks/useAdminUsersFetch';
import { useSelector } from 'react-redux';

import AdminUsersTable from './AdminUsersTable';
import CreateAdminUserModal from './CreateAdminUserModal';
import Title from 'lib/src/components/typography/Title';
import CreateHeader from '@components/layout/createHeader/CreateHeader';
import LinkButton from '@components/button/LinkButton';
import {
    getAdminUsers,
    //  getAdminUsersError,
    getAdminUsersIsFetching,
} from '@selectors/adminUsers';
import { useState } from 'react';
import UpdateAdminModal from './UpdateAdminModal';
import UpdateAdminPasswordModal from './UpdateAdminPasswordModal';
import DeleteAdminModal from './DeleteAdminModal';
import UpgradeAdminModal from './UpgradeAdminModal';
import DowngradeAdminModal from './DowngradeAdminModal';
import useRoles from 'lib/src/hooks/useRoles';
import { findRoleMatch } from 'lib/src/utils/generic';
import { userRoles } from 'lib/src/shared/enums/dropdownEnums';

const AdminUsers: React.FC<AdminUsersProps> = ({ showCreateModal = false }) => {
    useAdminUsersFetch();
    const adminUsers = useSelector(getAdminUsers);
    const isFetching = useSelector(getAdminUsersIsFetching);
    // const error = useSelector(getAdminUsersError);

    const [adminUserToEdit, setAdminUserToEdit] = useState<number | null>(null);
    const [adminUserToEditPassword, setAdminUserToEditPassword] = useState<number | null>(null);
    const [adminUserToDelete, setAdminUserToDelete] = useState<number | null>(null);
    const [adminUserToUpgrade, setAdminUserToUpgrade] = useState<number | null>(null);
    const [adminUserToDowngrade, setAdminUserToDowngrade] = useState<number | null>(null);

    const roles = useRoles();

    return (
        <>
            <CreateHeader>
                <Title>Admins</Title>
                {findRoleMatch(roles, [userRoles.admins, userRoles.superAdmin]) && (
                    <LinkButton color="green" icon="plus" href="/admins/create">
                        Create
                    </LinkButton>
                )}
            </CreateHeader>

            <AdminUsersTable
                adminUsers={adminUsers}
                isFetching={isFetching}
                setAdminUserToEdit={setAdminUserToEdit}
                setAdminUserToEditPassword={setAdminUserToEditPassword}
                setAdminUserToDelete={setAdminUserToDelete}
                setAdminUserToUpgrade={setAdminUserToUpgrade}
                setAdminUserToDowngrade={setAdminUserToDowngrade}
            />
            {showCreateModal && <CreateAdminUserModal />}
            {!!adminUserToEdit && (
                <UpdateAdminModal
                    user={adminUsers[adminUserToEdit]}
                    closeModal={() => setAdminUserToEdit(null)}
                />
            )}
            {!!adminUserToEditPassword && (
                <UpdateAdminPasswordModal
                    user={adminUsers[adminUserToEditPassword]}
                    closeModal={() => setAdminUserToEditPassword(null)}
                />
            )}
            {!!adminUserToDelete && (
                <DeleteAdminModal
                    user={adminUsers[adminUserToDelete]}
                    closeModal={() => setAdminUserToDelete(null)}
                />
            )}
            {!!adminUserToUpgrade && (
                <UpgradeAdminModal
                    user={adminUsers[adminUserToUpgrade]}
                    closeModal={() => setAdminUserToUpgrade(null)}
                />
            )}
            {!!adminUserToDowngrade && (
                <DowngradeAdminModal
                    user={adminUsers[adminUserToDowngrade]}
                    closeModal={() => setAdminUserToDowngrade(null)}
                />
            )}
        </>
    );
};

interface AdminUsersProps {
    showCreateModal?: boolean;
}

export default AdminUsers;
